import { NotificationModel, PaginationParams } from '@arpeggi/shared'

export interface GetNotificationsParams extends Omit<PaginationParams<NotificationModel>, 'read'> {
  isRead?: boolean
}
